import { KHMCTU_DEFAULT } from "constants/TaxDeductRegisterConstant";

export const errorInvoicesLoaiThongBao = [
  { key: "type1", value: "1", label: "Thông báo hủy/giải trình của NNT" },
  {
    key: "type2",
    value: "2",
    label: "Thông báo hủy/giải trình của NNT theo thông báo của CQT",
  },
];

export const MODE = {
  EDIT: "EDIT",
  VIEW: "VIEW",
};

export const errorInvoicesLoaiHoaDon = [
  { key: "TT78", value: "1", label: "Thông tư 78" },
  { key: "TT32", value: "2", label: "Thông tư 32" },
  { key: "ND51", value: "3", label: "Nghị định 51" },
  { key: "HD_Giay", value: "4", label: "Hóa đơn giấy" },
];

export const TypeHDList = [
  { value: 0, label: "HĐĐT TT78" },
  { value: 1, label: "HĐ từ Máy tính tiền" },
];

export const IS_POS_LABEL = {
  1: "HĐ từ Máy tính tiền",
  0: "HĐĐT TT78",
};

export const KyHieuMauHoaDonList = [
  { key: "VAT", value: "1", label: "1 - HĐ GTGT", prefix: "T" },
  { key: "SALE", value: "2", label: "2 - HĐ bán hàng", prefix: "T" },
  //   { key: "TICKETS", value: "5", label: "5 - HĐ tem phiếu", prefix: "G" },
  { key: "WAREHOUSES", value: "6", label: "6 - Phiếu xuất kho", prefix: "N" },
];

export const KyHieuMauCTUList = [
  { key: KHMCTU_DEFAULT, value: KHMCTU_DEFAULT, label: KHMCTU_DEFAULT },
];

export const invoiceTypeMode = {
  HAVE_CODE: "1",
  NONE_CODE: "0",
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da} 00:00:00`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const tableFormateDate = (data, isSecond = false) => {
  if (new Date(Number(data)).toString() !== "Invalid Date") {
    if (isSecond) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "numeric",
      }).format(data * 1000);
    } else {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        // hour: "2-digit",
        // minute: "2-digit",
      }).format(data * 1000);
    }
  }
  return "";
};

export const LADHDDT_LABEL = {
  1: "HĐĐT theo Nghị định 123/2020/NĐ-CP ( Thông tư 78 )",
  2: "HĐĐT theo Quyết định số 1209/QĐ-BTC ( Thông tư 32 có mã xác thực CQT )",
  3: "HĐĐT theo Nghị định số 51/2010/NĐ-CP ( Thông tư 32 )",
  4: "Hoá đơn đặt in",
};

export const LCTDT_LABEL = {
  1: "Chứng từ điện tử khấu trừ thuế TNCN theo Nghị định 70",
  2: "Chứng từ điện tử khấu trừ thuế đối với hoạt động kinh doanh trên nền tảng thương mại điện tử, nền tảng số",
  3: "Biên lai thu thuế, phí, lệ phí không in sẵn mệnh giá theo Nghị định 70",
  4: "Biên lai thu thuế, phí, lệ phí in sẵn mệnh giá theo Nghị định 70",
  5: "Biên lai thu thuế, phí, lệ phí của cơ quan thuế sử dụng khi thu thuế, phí, lệ phi của cá nhân",
  6: "Biên lai thu thuế, phí, lệ phí đặt in, tự in, điện tử theo Thông tư 303/2016/TT-BTC, Nghị định 51/2010/NĐ-CP",
};

export const TCTBAO_LABEL = {
  0: "0 - Mới",
  1: "1 - Hủy",
  2: "2 - Điều chỉnh",
  3: "3 - Thay thế",
  4: "4 - Giải trình",
  5: "5 - Sai sót do tổng hợp",
};
